import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { availability } from '../data/portfolio';
import { Label } from './Label';
export function Availability() {
  return <section id="availability" aria-labelledby="availability-heading" className="mesh scroll-mt-20 px-6 py-24 md:px-10 md:py-32" data-id="element-15" data-mp="2vbnxcfb3oej2">
      <div className="relative z-[1] mx-auto w-full max-w-edge" data-id="element-16" data-mp="30biomjysf64n">
        <Label data-id="element-17" data-mp="3nzs5r8l235pg">Appointment Proposition</Label>

        <h2 id="availability-heading" className="mt-10 max-w-4xl font-display text-[2.75rem] font-normal leading-[1.04] text-paper md:text-[4.5rem]" data-id="element-18" data-mp="3o136t0n49zcv">
          Available for Board appointments
        </h2>

        <p className="mt-10 max-w-2xl font-display text-xl font-normal leading-[1.5] text-paper/90 md:text-2xl" data-id="element-19" data-mp="3j18jf72jvrwk">
          {availability.statement}
        </p>

        <ul className="mt-16 flex flex-wrap items-center gap-x-10 gap-y-4 border-t border-white/15 pt-8" data-id="element-20" data-mp="22lno649kgfae">
          {availability.disciplines.map(discipline => <li key={discipline} className="text-[0.85rem] uppercase tracking-[0.26em] text-brass" data-id="element-21" data-mp="1mc9jgdvmwuwb">
              {discipline}
            </li>)}
        </ul>

        <a href="#contact" className="group mt-12 inline-flex items-center gap-4 border-b border-paper/40 pb-2 text-[0.8rem] uppercase tracking-[0.26em] text-paper transition-colors duration-150 ease-editorial hover:border-brass hover:text-brass focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-4 focus-visible:outline-brass" data-id="element-22" data-mp="1veiporjve23w">
          Contact Nigel
          <ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-150 ease-editorial group-hover:translate-x-1" aria-hidden="true" data-id="element-23" data-mp="2e2xinkdqzq7c" />
        </a>
      </div>
    </section>;
}